import React, { useEffect, useState, useCallback } from "react";
import { StyleSheet, View, Text } from "react-native-web";
import { Images, Colors, Fonts, Constants } from "../../../../config";
import { useTranslation } from "react-i18next";
import { CImage } from "../../../../components/atoms";
import { formatNumber } from "../../../../helpers";
import { formatCurrency, getClass } from "../../../../helpers/formatHelpers";
import { minBy } from "lodash";

const SubListCardView = (props) => {
  const { t } = useTranslation();

  if (!props.item) return null;
  const { isMobileVersion, category, title } = props;
  const { id, otherHomes, companyHomes } = props.item;

  const totalAllString = formatNumber(
    category === Constants.categoryType.CATEGORY_PREFAB_HOMES
      ? otherHomes?.filter((i) => i.id !== id)?.length
      : companyHomes?.length
  );
  const fromPriceString =
    category === Constants.categoryType.CATEGORY_ZOO
      ? formatCurrency(formatNumber(props.item?.tag_price))
      : formatCurrency(
          formatNumber(minBy(companyHomes, "tag_price")?.tag_price)
        );
  const fromSizeString = formatNumber(
    minBy(companyHomes, "tag_size")?.tag_size?.toString()?.split(".")[0]
  );
  return (
    <View style={[styles.profileCardItemContainer, props.style]}>
      <View style={[styles.rowContainer, { flex: 7 }]}>
        <Text
          style={[
            styles.tagTitle,
            isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
          ]}>
          <h2>{title}</h2>
        </Text>
        <Text
          style={[
            styles.memberCountText,
            isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
          ]}>
          {totalAllString}
        </Text>
      </View>

      {(category === Constants.categoryType.CATEGORY_ZOO ||
        category === Constants.categoryType.CATEGORY_PREFAB_COMPANY) && (
        <View style={[styles.rowContainer, { flex: 8 }]}>
          <Text
            style={[
              styles.text,
              isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
            ]}>
            From
          </Text>
          <Text
            style={[
              styles.grayText,
              isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
              ,
              { marginLeft: 4 },
            ]}>
            {fromPriceString}
          </Text>
          {category !== Constants.categoryType.CATEGORY_ZOO && (
            <View style={styles.splitter} />
          )}
          {category !== Constants.categoryType.CATEGORY_ZOO && (
            <Text
              style={[
                styles.text,
                isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
              ]}>
              Min
            </Text>
          )}
          {category !== Constants.categoryType.CATEGORY_ZOO && (
            <Text
              style={[
                styles.grayText,
                isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
                ,
                { marginLeft: 4 },
              ]}>
              Min {fromSizeString} sqft
            </Text>
          )}
        </View>
      )}

      <View>
        <CImage
          width={18}
          height={18}
          layout="fixed"
          source={Images.iconAngleRight}
          style={styles.angleIcon}
          resizeMode="contain"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  profileCardItemContainer: {
    height: 70,
    alignSelf: "stretch",
    borderRadius: 25,
    backgroundColor: getClass("bg-gray1"),
    marginHorizontal: 16,
    paddingHorizontal: 30,
    flexDirection: "row",
    alignItems: "center",
  },
  tagTitle: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: Fonts.primaryBold,
    color: "white",
  },
  grayText: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryBold,
    color: getClass("text-gray2"),
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryBold,
    color: "white",
  },
  angleIcon: {
    width: 16,
    height: 16,
  },
  memberCountText: {
    marginLeft: 12,
    fontSize: 18,
    lineHeight: 22,
    fontFamily: Fonts.primaryBold,
    color: getClass("text-gray2"),
  },
  splitter: {
    width: 1,
    height: 16,
    borderRadius: 1,
    backgroundColor: Colors.spliterLine,
    marginHorizontal: 6,
  },
});

export default SubListCardView;
